import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchSecretarias } from '../../api/endpoints';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { getIdCidadeEcrie, getTotem } from '../../api/apiFactory';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import {
  resetarModais, selectModal, abrirModalServico, fecharModalServico,
} from '../../app/slices/modalSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalServico from '../../components/ModalServico/ModalServico';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import {
  Alerta, AppBody, AppFragment, CampoForm,
  Container, Divisor, Grid, Linha, Titulo,
  GridServicos,
  BreadCumbs,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';

const SelecionarServicoTotem = () => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const history = useHistory();

  const dispatch = useDispatch();

  const dadosCidade = useSelector(selectCidade);

  const dadosModal = useSelector(selectModal);

  window.onload = () => {
    dispatch(resetarModais());
  };

  window.onload = () => {
    dispatch(resetarModais());
  };

  useEffect(() => {
    dispatch(desfazerSecretaria());
    if (dadosCidade.data) {
      fetchSecretarias().then(setListaSecretarias);
    }
    if (!(getIdCidadeEcrie() > 0)) {
      history.push('/');
    }
  }, []);

  if (dadosCidade.data && !listaSecretarias) {
    return (
      <Carregar />
    );
  }

  if (dadosCidade.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda />)}
        {dadosModal.modalServico === 'aberto' && (<ModalServico />)}
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => history.push('/totem')}
        />
        <AppBody totem desfoque={dadosModal.desfoque}>
          <BreadCumbs>
            Você está em:
            {' '}
            <span style={{ fontWeight: 'bold' }}>Serviços</span>
          </BreadCumbs>
          <Container style={{ marginTop: 180 }} totem>
            <GridServicos>
              <GridBotao
                onClick={() => history.push('/totem/agendas')}
                label="Agenda"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/agenda.png"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#0c0c0c24"
                secretaria2
              />
              <GridBotao
                onClick={() => history.push('/totem/coletas')}
                label="Coleta de Lixo"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/lixo3.png"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#0c0c0c24"
                secretaria2
              />
              <GridBotao
                onClick={() => history.push('/totem/eventos')}
                label="Eventos"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/eventos-icone.png"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#0c0c0c24"
                secretaria2
              />
              <GridBotao
                onClick={() => history.push('/totem/noticias')}
                label="Notícias"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/jornal.svg"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#f7e6a78c"
                secretaria2
              />
              <GridBotao
                onClick={() => history.push('/totem/telefones')}
                label="Telefones Úteis"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/telefone.png"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#f7e6a78c"
                secretaria2
              />
              <GridBotao
                onClick={() => history.push('/totem/transportes')}
                label="Transporte Coletivo"
                img="https://ecrie.com.br/Sistema/Arquitetura/Icones/onibus3.png"
                size={16}
                imgWidth={47}
                imgHeight={47}
                cor="#f7e6a78c"
                secretaria2
              />
            </GridServicos>
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  return (
    true
  );
};

export default SelecionarServicoTotem;
